import { approvalStatus } from '../../utils/approvalStatus.js';

const UNKNOWN_NAME = 'Unknown';

export function shiftsFor(shiftsByOrganization, organizationId) {
  return (organizationId && shiftsByOrganization[organizationId]) || [];
}

function placementCovers(row, date) {
  const hasStartedBy = !row.startDate || row.startDate <= date;
  const hasNotEndedBefore = !row.endDate || date <= row.endDate;

  return hasStartedBy && hasNotEndedBefore;
}

function blankHourRecord(row, date) {
  return {
    id: null,
    employment: {
      id: row.employmentId,
      client: row.organization,
      flexworker: row.name
    },
    date,
    hours: 0,
    overtime: 0,
    extra_payment: 0,
    shift_allowance: 0,
    shift: null,
    status: 'pending',
    edited_by: null,
    approved_by: null,
    exported_at: null,
    updated_at: null
  };
}

function emptyRowFor(placement, lastDayOfWeek) {
  const { organization, end_date: endDate } = placement;
  const hasEndedByThisWeek = Boolean(endDate) && endDate <= lastDayOfWeek;

  return {
    id: placement.flexworker_id,
    employmentId: placement.employment_id,
    change_password: placement.change_password,
    name: placement.name || UNKNOWN_NAME,
    organization: organization ? organization.name : '',
    organizationId: organization ? organization.id : null,
    startDate: placement.start_date,
    endDate,
    shownEndDate: hasEndedByThisWeek ? endDate : null,
    canReceiveMessages: placement.can_receive_messages,
    _hoursDetails: []
  };
}

/**
 * Keyed by employment id. Every row is built here, so a total can never
 * carry over from an earlier run. Note this does adopt the given
 * hoursRecords: it canonicalises their shift reference and keeps them.
 */
export function buildWeekRows(roster, hoursRecords, shifts, weekDays) {
  const lastDayOfWeek = weekDays[weekDays.length - 1];
  const rows = roster.reduce((map, placement) => {
    map[placement.employment_id] = emptyRowFor(placement, lastDayOfWeek);
    return map;
  }, {});

  hoursRecords.forEach(rec => {
    const row = rows[rec.employment.id];
    if (!row) return;

    // Replace the shift object with the matching reference from
    // the shifts array so Vue's <select> v-model can match by ===
    if (rec.shift && rec.shift.id) {
      const match = shiftsFor(shifts, row.organizationId).find(s => s.id === rec.shift.id);
      if (match) rec.shift = match;
    }

    row._hoursDetails.push(rec);
  });

  Object.values(rows).forEach(row => {
    const have = new Set(row._hoursDetails.map(r => r.date));
    weekDays
      .filter(date => !have.has(date))
      .forEach(date => row._hoursDetails.push(blankHourRecord(row, date)));
    row._hoursDetails.forEach(detail => {
      detail.outsidePlacement = !placementCovers(row, detail.date);
      detail.savedStatus = detail.status;
    });
    row._hoursDetails.sort((a, b) => a.date.localeCompare(b.date));
    row.approvalStatus = approvalStatus(row._hoursDetails);
  });

  return rows;
}
